export function PreventSpaceDirective() {
  return function (scope, element, attrs) {
    element.bind('input', function (event) {
      if (event.which === 32) {
        event.preventDefault();
      }

      element.val(element.val().replace(/ /g, '')); // Just in case oc copy/paste
    });
  };
}
